// src/components/landingPage/Header.tsx

import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import StoryCounter from "./header/StoryCounter";
import "../../styles/components/landingPage/Header.css";

interface NavItem {
  to: string;
  label: string;
  requiresAuth?: boolean;
}

const Header: React.FC = () => {
  const { user, userProfile, loadingProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems: NavItem[] = [
    { to: "/", label: "Mundwerte" },
    { to: "/vision", label: "Vision" },
    { to: "/story-collection", label: "Geschichten", requiresAuth: true },
    { to: "/dashboard", label: "Dashboard", requiresAuth: true },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const displayName = userProfile?.displayName || user?.email || "Gast";

  return (
    <header className={`header${menuOpen ? " menu-open" : ""}`}>
      {/* Mobile Toggle */}
      <button
        className="nav-toggle"
        onClick={() => setMenuOpen(open => !open)}
        aria-label="Navigation umschalten"
        aria-expanded={menuOpen}
      >
        ☰
      </button>

      {/* Logo */}
      <h1 className="logo" onClick={() => navigate("/")}>
        Mundwerte
      </h1>

      {/* Navigation */}
      <ul className={`nav-links${menuOpen ? " open" : ""}`}>
        {navItems.map(({ to, label, requiresAuth }) => {
          if (requiresAuth && !user) return null;
          return (
            <li key={to}>
              <NavLink
                to={to}
                end
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </NavLink>
            </li>
          );
        })}
      </ul>

      {/* User Controls always visible */}
      <div className="user-controls">
        {user && (
          <div className="nav-counter" aria-label="Gelesene Geschichten">
            <StoryCounter />
          </div>
        )}
        {user && (
          <span className="user-info" aria-live="polite">
            {loadingProfile ? "Profil lädt..." : `Willkommen, ${displayName}`}
          </span>
        )}
        {user ? (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <NavLink
            to="/login"
            end
            className="login-link"
            onClick={() => setMenuOpen(false)}
          >
            Login
          </NavLink>
        )}
      </div>
    </header>
  );
};

export default Header;
